import React from 'react';
import { toast as _toast } from 'react-toastify';
import ToastContent from 'Shared/UI/ToastContent';

const WRAPPER_STYLE = {
  background: 'transparent',
  boxShadow: 'none',
  padding: 0,
  minWidth: 'auto',
};

const show = (severity) => (message, options = {}) => _toast(
  <ToastContent severity={severity} message={message} />,
  {
    style: WRAPPER_STYLE,
    bodyStyle: { padding: 0, margin: 0 },
    hideProgressBar: true,
    closeButton: false,
    ...options,
  },
);

const toast = {
  success: show('success'),
  error: show('error'),
  info: show('info'),
  warning: show('warning'),
};

export default toast;
